import React from "react";
import { Card, Col } from "react-bootstrap";
import ApexCharts from "react-apexcharts";
import { useSelector } from "react-redux";

const MonthlyClaimsVolumeTrend = () => {
  const { claimDashboardData } = useSelector((state) => state.claimDashboard);

  // Extract monthly data
  const monthsData = [
    claimDashboardData?.claim_previous_month5,
    claimDashboardData?.claim_previous_month4,
    claimDashboardData?.claim_previous_month3,
    claimDashboardData?.claim_previous_month2,
    claimDashboardData?.claim_previous_month,
    claimDashboardData?.claim_current_month,
  ].filter(Boolean); // Remove undefined/null entries

  // Generate month labels (e.g., "May 2025", "Jun 2025", ..., "Oct 2025")
  const monthLabels = monthsData.map((month) => {
    const [year, monthNum] = month.month_year.split("-");
    const date = new Date(year, monthNum - 1);
    return date.toLocaleString("en-US", { month: "short", year: "numeric" });
  });

  // Define categories
  const categories = [
    { key: "approved", name: "Approved" },
    { key: "partial", name: "Partially Approved" },
    { key: "rejected", name: "Rejected" },
    { key: "others", name: "Others" },
  ];

  // Calculate series data
  const seriesData = categories.map((category) => {
    const data = monthsData.map((month) => {
      if (category.key === "others") {
        // Sum all statuses except approved, partial, and rejected
        return (
          (month.pended || 0) +
          (month.noresp || 0) +
          (month.error || 0) +
          (month.claim_current_month || 0) +
          (month.invalid || 0) +
          (month["validation-error"] || 0) +
          (month.cancel || 0) +
          (month.queue || 0) +
          (month.adjudication || 0) +
          (month["not-required"] || 0)
        );
      }
      return month[category.key] || 0;
    });
    return {
      name: category.name,
      data,
    };
  });

  // Calculate max y-axis value (round up to nearest 100)
  const maxClaims = Math.max(...monthsData.map((month) => month.total || 0));
  const yAxisMax = Math.ceil(maxClaims / 100) * 100 || 100;

  const chartOptions = {
    series: seriesData,
    options: {
      chart: {
        type: "area",
        height: 250,
        stacked: true,
        toolbar: { show: false },
        zoom: { enabled: false },
      },
      dataLabels: { enabled: false },
      stroke: {
        curve: "smooth",
        width: 0,
      },
      fill: {
        opacity: 1,
      },
      xaxis: {
        categories: monthLabels,
        labels: { rotate: 0, style: { fontSize: "10px" } },
      },
      yaxis: {
        min: 0,
        max: yAxisMax,
        tickAmount: 5,
        labels: { style: { fontSize: "10px" } },
      },
      colors: [
        "hsla(120, 98%, 50%, 1.00)", // Green for Approved
        "rgba(1, 138, 250, 1)", // Blue for Partially Approved
        "hsla(0, 94%, 48%, 1.00)", // Red for Rejected
        "hsla(0, 0%, 60%, 1.00)", // Gray for Others
      ],
      tooltip: {
        y: {
          formatter: (val) => val,
        },
      },
      legend: {
        position: "bottom",
        horizontalAlign: "center",
        fontSize: "10px",
        markers: {
          shape: "circle",
        },
      },
    },
  };

  return (
    <Col xs={12}>
      <Card className="h-100 p-3">
        <Card.Header as="h6" className="fs-9  fw-normal text-primary">
          Monthly Claims Volume Trend
        </Card.Header>
        <Card.Body className="p-2">
          <ApexCharts
            options={chartOptions.options}
            series={chartOptions.series}
            type="area"
            height={250}
            width="100%"
          />
        </Card.Body>
      </Card>
    </Col>
  );
};

export default MonthlyClaimsVolumeTrend;
